export enum ELegacyMetadataTypes {
  title = '2b754052-a2ae-430f-afb3-60ab0a242045',
  state = 'b6e6311c-343b-4b79-bf45-113b8b20186e',
  documentFromSnapshot = 'f6908079-cf09-4312-9632-2c113da5ddde', // @info former `sharedAsCopyId`
  documentFromPrompt = '5f303959-f0f7-4548-aedd-717f94d5b794', // @info `extendDocumentWithAiId`
  explainANode = 'd05908aa-ff5e-448c-97a7-9bf5ca5437aa',
  detailANodeWithAdditionalSteps = '3a58a53d-7fbb-4d33-ad1a-5253ed6888d4',
}
